// bundle-pillow-selector.js

document.addEventListener('DOMContentLoaded', function () {
  mountBadgesOnMedia();
  document.querySelectorAll('.bps').forEach(root => {
    relocateForDesktop(root);
    relocateSocialProofForDesktop(root);
    initBundleSelector(root);
    initSocialProof(root);
  });
});

function relocateSocialProofForDesktop(root) {
  const social = root.querySelector('.bps__social-proof');
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  if (!social || !mediaWrapper) return;

  const originalParent = social.parentElement;
  const originalNext = social.nextSibling;
  const mq = window.matchMedia('(min-width: 750px)');

  function apply(e) {
    if (e.matches) {
      mediaWrapper.appendChild(social);
    } else if (social.parentElement !== originalParent) {
      if (originalNext && originalNext.parentElement === originalParent) {
        originalParent.insertBefore(social, originalNext);
      } else {
        originalParent.appendChild(social);
      }
    }
  }

  apply(mq);
  mq.addEventListener('change', apply);
}

function initSocialProof(root) {
  const social = root.querySelector('.bps__social-proof');
  if (!social) return;

  social.querySelectorAll('.bps__video-mute').forEach(btn => {
    btn.addEventListener('click', () => {
      const video = btn.previousElementSibling;
      if (!video) return;
      video.muted = !video.muted;
      btn.textContent = video.muted ? '🔇' : '🔊';
    });
  });

  const track = social.querySelector('.bps__video-track');
  const nextBtn = social.querySelector('.bps__video-next');
  if (track && nextBtn) {
    nextBtn.addEventListener('click', () => {
      const card = track.querySelector('.bps__video-card');
      const step = card ? card.getBoundingClientRect().width + 8 : 118;
      track.scrollBy({ left: step, behavior: 'smooth' });
    });
  }
}

function relocateForDesktop(root) {
  const infoWrapper = document.querySelector('.product__info-wrapper');
  if (!infoWrapper) return; // theme markup not found - leave the section where it is

  const productGrid = infoWrapper.closest('.product') || infoWrapper.parentElement;
  const originalParent = root.parentElement;
  const originalNext = root.nextSibling;
  const mq = window.matchMedia('(min-width: 750px)');

  function apply(e) {
    if (e.matches) {
      infoWrapper.appendChild(root);
      if (productGrid) productGrid.classList.add('bps-layout-active');
    } else {
      if (root.parentElement !== originalParent) {
        if (originalNext && originalNext.parentElement === originalParent) {
          originalParent.insertBefore(root, originalNext);
        } else {
          originalParent.appendChild(root);
        }
      }
      if (productGrid) productGrid.classList.remove('bps-layout-active');
    }
  }

  apply(mq);
  mq.addEventListener('change', apply);
}

function mountBadgesOnMedia() {
  const badge = document.querySelector('.bps__bestseller-badge');
  const pill = document.querySelector('.bps__shipping-pill');
  const toprow = document.querySelector('.bps__header-toprow');
  if (!badge && !pill) return;

  const mediaTarget = document.querySelector('.product__media');
  if (!mediaTarget) return; // theme markup not found - badges stay in the header as a fallback

  if (getComputedStyle(mediaTarget).position === 'static') {
    mediaTarget.style.position = 'relative';
  }

  const overlay = document.createElement('div');
  overlay.className = 'bps-media-overlay';
  if (pill) overlay.appendChild(pill);
  if (badge) overlay.appendChild(badge);
  mediaTarget.appendChild(overlay);

  if (toprow && toprow.children.length === 0) toprow.remove();
}

function initBundleSelector(root) {
  const form = root.querySelector('.bps__form');
  const tiers = root.querySelectorAll('.bps__tier');
  const variantPickers = root.querySelectorAll('.bps__variant-picker');
  const submitBtn = root.querySelector('.bps__add-to-cart');
  const priceLabel = root.querySelector('.bps__atc-price');
  const viewersCountEl = root.querySelector('.bps__viewers-count');
  const addons = root.querySelectorAll('.bps__addon');
  const addonPickers = root.querySelectorAll('.bps__addon-variant-picker');
  const maxTierQty = parseInt(root.dataset.maxTierQty || '1', 10);

  const sectionId = root.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');
  const cfg = (window.__bpsConfig && sectionId && window.__bpsConfig[sectionId]) || {};
  const currencySymbol = cfg.currency || '';

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return currencySymbol + amount;
  }

  function refreshAddonPickers(addon, qty) {
    const key = addon.dataset.addonKey;
    const checkbox = addon.querySelector('.bps__addon-checkbox');
    const isChecked = checkbox && checkbox.checked;
    addonPickers.forEach(p => {
      if (p.dataset.addonKey === key) {
        p.hidden = !(isChecked && parseInt(p.dataset.qty, 10) === qty);
      }
    });
  }

  function setAddonQty(addon, qty) {
    qty = Math.max(1, Math.min(qty, maxTierQty || qty));
    qty = Math.min(qty, 3); // only qty 1/2/3 have configured prices

    const lineTotal = parseFloat(addon.dataset['priceQty' + qty + 'Was'] || '0');
    const finalTotal = parseFloat(addon.dataset['priceQty' + qty + 'Now'] || '0');
    const each = qty > 0 ? finalTotal / qty : finalTotal;

    const staticNum = addon.querySelector('.bps__addon-qty-static-num');
    const stepperNum = addon.querySelector('.bps__addon-qty-num');
    const staticBadge = addon.querySelector('.bps__addon-badge-static');
    const wasEl = addon.querySelector('.bps__addon-price-was');
    const nowEl = addon.querySelector('.bps__addon-price-now');
    const eachEl = addon.querySelector('.bps__addon-price-each');
    const checkbox = addon.querySelector('.bps__addon-checkbox');

    if (staticNum) staticNum.textContent = qty;
    if (stepperNum) stepperNum.textContent = qty;
    if (staticBadge) staticBadge.hidden = qty <= 1;
    if (wasEl) wasEl.textContent = formatMoney(lineTotal);
    if (nowEl) nowEl.textContent = formatMoney(finalTotal);
    if (eachEl) {
      const eachLabel = eachEl.textContent.replace(/^[^\s]+\s/, '');
      eachEl.textContent = formatMoney(each) + (eachLabel ? ' ' + eachLabel : '');
    }
    if (checkbox) checkbox.dataset.qty = qty;
    addon.dataset.currentQty = qty;

    refreshAddonPickers(addon, qty);
  }

  function updateAddonsForQty(tierQty) {
    addons.forEach(addon => setAddonQty(addon, tierQty));
  }

  function refreshAddonControlVisibility(addon) {
    const checkbox = addon.querySelector('.bps__addon-checkbox');
    const staticBadge = addon.querySelector('.bps__addon-badge-static');
    const stepper = addon.querySelector('.bps__addon-stepper');
    const qty = parseInt(addon.dataset.currentQty || '1', 10);
    if (checkbox.checked) {
      if (stepper) stepper.hidden = false;
      if (staticBadge) staticBadge.hidden = true;
    } else {
      if (stepper) stepper.hidden = true;
      if (staticBadge) staticBadge.hidden = qty <= 1;
    }
    refreshAddonPickers(addon, qty);
  }

  addons.forEach(addon => {
    const checkbox = addon.querySelector('.bps__addon-checkbox');
    checkbox.addEventListener('change', () => refreshAddonControlVisibility(addon));
    refreshAddonControlVisibility(addon);

    addon.querySelectorAll('.bps__stepper-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt(addon.dataset.currentQty || '1', 10);
        const next = btn.dataset.action === 'inc' ? current + 1 : current - 1;
        setAddonQty(addon, next);
      });
    });
  });

  function selectTier(tier) {
    tiers.forEach(t => t.classList.remove('bps__tier--selected'));
    tier.classList.add('bps__tier--selected');
    tier.querySelector('.bps__tier-radio').checked = true;

    const qty = parseInt(tier.dataset.qty, 10);
    variantPickers.forEach(vp => {
      vp.hidden = parseInt(vp.dataset.tierQty, 10) !== qty;
    });

    const finalTotal = parseFloat(tier.dataset.finalTotal || '0');
    if (priceLabel) priceLabel.textContent = formatMoney(finalTotal);

    updateAddonsForQty(qty);
    addons.forEach(refreshAddonControlVisibility);
  }

  tiers.forEach(tier => {
    tier.addEventListener('click', () => selectTier(tier));
  });

  const preselected = root.querySelector('.bps__tier--selected') || tiers[0];
  if (preselected) selectTier(preselected);

  // swatch selection (main pillow + addon pickers)
  root.querySelectorAll('.bps__swatches').forEach(group => {
    group.querySelectorAll('.bps__swatch').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        group.querySelectorAll('.bps__swatch').forEach(b => b.classList.remove('bps__swatch--selected'));
        btn.classList.add('bps__swatch--selected');
        const nameEl = group.closest('.bps__variant-row')?.querySelector('.bps__variant-row-name');
        if (nameEl) nameEl.textContent = btn.getAttribute('title') || '';
      });
    });
  });

  // "See N more add-ons"
  const moreBtn = root.querySelector('.bps__addons-more');
  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      root.querySelectorAll('.bps__addon-extra').forEach(el => { el.hidden = false; });
      moreBtn.hidden = true;
    });
  }

  // scroll to reviews section when clicking the review count
  const reviewsLink = root.querySelector('.js-bps-scroll-reviews');
  if (reviewsLink) {
    reviewsLink.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = reviewsLink.dataset.scrollTarget;
      const target = targetId ? document.getElementById(targetId) : null;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // live viewer count - natural random walk instead of full jumps
  if (viewersCountEl) {
    const viewerMin = cfg.viewerMin || 18;
    const viewerMax = cfg.viewerMax || 45;
    let current = parseInt(viewersCountEl.textContent, 10) || viewerMin;
    setInterval(() => {
      const step = Math.floor(Math.random() * 3) + 1; // 1-3
      const direction = Math.random() < 0.5 ? -1 : 1;
      current = current + (step * direction);
      current = Math.max(viewerMin, Math.min(viewerMax, current));
      viewersCountEl.textContent = current;
    }, 4000);
  }

  async function tryOpenCartNotification() {
    const notif = document.getElementById('cart-notification');
    if (!notif) return false;

    try {
      const res = await fetch('/?sections=cart-notification-product,cart-notification-button,cart-icon-bubble');
      if (res.ok) {
        const data = await res.json();
        const parser = new DOMParser();

        [
          ['cart-notification-product', 'cart-notification-product'],
          ['cart-notification-button', 'cart-notification-button'],
          ['cart-icon-bubble', 'cart-icon-bubble']
        ].forEach(([sectionKey, elementId]) => {
          const html = data[sectionKey];
          const el = document.getElementById(elementId);
          if (html && el) {
            const doc = parser.parseFromString(html, 'text/html');
            const fresh = doc.getElementById(elementId);
            if (fresh) el.innerHTML = fresh.innerHTML;
          }
        });
      }
    } catch (err) {
      console.warn('BPS: could not refresh cart notification contents', err);
    }

    notif.classList.add('active', 'animate');
    notif.removeAttribute('hidden');

    clearTimeout(notif.__bpsCloseTimer);
    notif.__bpsCloseTimer = setTimeout(() => {
      notif.classList.remove('active');
    }, 6000);

    return true;
  }

  async function tryOpenCartDrawer() {
    // Our own custom cart drawer, if installed on this page
    if (window.BPSCart && typeof window.BPSCart.open === 'function') {
      window.BPSCart.open();
      return true;
    }

    // Dawn theme: <cart-drawer> custom element
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      try {
        const res = await fetch('/?sections=cart-drawer');
        if (res.ok) {
          const data = await res.json();
          const html = data['cart-drawer'];
          if (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('cart-drawer');
            if (fresh) cartDrawerEl.innerHTML = fresh.innerHTML;
          }
        }
      } catch (err) {
        console.warn('BPS: could not refresh cart drawer contents', err);
      }

      if (typeof cartDrawerEl.open === 'function') {
        cartDrawerEl.open();
        return true;
      }
      cartDrawerEl.classList.add('active', 'animate');
      document.documentElement.classList.add('overflow-hidden');
      return true;
    }

    // Dawn theme: "Notification" cart type (popup near the cart icon)
    if (await tryOpenCartNotification()) return true;

    // Generic fallbacks for other themes
    if (typeof window.theme?.openCartDrawer === 'function') { window.theme.openCartDrawer(); return true; }
    if (typeof window.Shopify?.theme?.cart?.open === 'function') { window.Shopify.theme.cart.open(); return true; }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    const trigger = document.querySelector(
      'a[href="/cart"], [data-cart-icon], #cart-icon-bubble, .header__icon--cart, button[aria-controls*="cart" i], [data-cart-drawer-toggle]'
    );
    if (trigger) { trigger.click(); return true; }
    return false;
  }

  // submit -> add to cart
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    submitBtn.disabled = true;

    const selectedTier = root.querySelector('.bps__tier--selected');
    const qty = parseInt(selectedTier.dataset.qty, 10);
    const items = [];

    const activePicker = root.querySelector(`.bps__variant-picker[data-tier-qty="${qty}"]`);
    if (activePicker) {
      let slotIndex = 0;
      const submissionToken = Date.now() + '-' + Math.random().toString(36).slice(2, 6);
      activePicker.querySelectorAll('.bps__swatches').forEach(group => {
        const selected = group.querySelector('.bps__swatch--selected');
        if (selected) {
          slotIndex += 1;
          items.push({
            id: parseInt(selected.dataset.variantId, 10),
            quantity: 1,
            properties: { '_bps_slot': submissionToken + '-' + slotIndex, '_bps_bundle': root.dataset.productHandle || '' }
          });
        }
      });
    } else {
      const defaultVariantId = root.dataset.defaultVariantId;
      if (defaultVariantId) items.push({ id: parseInt(defaultVariantId, 10), quantity: qty });
    }

    root.querySelectorAll('.bps__addon-checkbox:checked').forEach(cb => {
      const addon = cb.closest('.bps__addon');
      const addonQty = parseInt(cb.dataset.qty, 10);
      const key = addon?.dataset.addonKey;
      const visiblePicker = key ? root.querySelector(`.bps__addon-variant-picker[data-addon-key="${key}"]:not([hidden])`) : null;

      if (visiblePicker) {
        visiblePicker.querySelectorAll('.bps__swatches').forEach(group => {
          const selected = group.querySelector('.bps__swatch--selected');
          if (selected) items.push({ id: parseInt(selected.dataset.variantId, 10), quantity: 1 });
        });
      } else {
        items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: addonQty });
      }
    });

    if (items.length === 0) {
      console.error('BPS: nenhum item para adicionar ao carrinho.');
      submitBtn.disabled = false;
      alert('Não foi possível determinar o produto a adicionar. Verifica a configuração da secção.');
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      if (!(await tryOpenCartDrawer())) {
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error(err);
      alert('Não foi possível adicionar ao carrinho. Tenta novamente.');
    } finally {
      submitBtn.disabled = false;
    }
  });
}
